// @ts-nocheck
import { Component, h, render } from "preact";

import { deepToPairs } from "@/utils/toPairsDeep";
import { useLimitation } from "@/hooks/useLimitation";
import { useMemo } from "preact/hooks";
import { useShopSettings } from "@/hooks/useShopSettings";

const DefaultTheme = {
  common: {
    starsWidget: {
      starsColor: "#000000",
      starsSize: 16,

      textSize: 14,

      ratingValueColor: "#5d5d5d",
      reviewsCountColor: "#000000",
    },
    reviewsListCollapseWidget: {
      headingColor: "#000000",
      headingSize: 28,

      dividerLinesColor: "#b3b3b3", //

      readMoreColor: "#858585",
      readMoreSize: 14,

      closeColor: "#000000",
      closeSize: 30,
    },
    reviewsListWidget: {
      headingSize: 26,
      headingColor: "#000000",
      headingBottomLineColor: "#e5e5e5", //

      starsColor: "#000000",
      starsSize: 16,

      nameColor: "#808080",
      nameSize: 14,

      dateColor: "#808080",
      dateSize: 14,

      reviewTextSize: 16,
      reviewTextColor: "#000000",

      imagePreviewSize: 50,

      usefulTextSize: 12,
      usefulTextColor: "#5d5d5d",
      usefulIconsColor: "#000000",
      usefulIconsSize: 16,
      usefulCountColor: "#000000",

      answerTitleSize: 16,
      answerTitleColor: "#000000",
      answerDateSize: 12,
      answerDateColor: "#5d5d5d",
      answerTextSize: 16,
      answerTextColor: "#000000",

      showMoreBtnTextSize: 18,
      showMoreBtnBackground: "#000000",
      showMoreBtnColor: "#ffffff",

      sortingReviewsBackgroundColor: "#ffffff",
      sortingReviewsTextColor: "#000000",
    },
    reviewFormWidget: {
      formBackground: "#f5f5f5",
      formBorderRadius: 20,

      headingSize: 26,
      headingColor: "#000000",
      headingBottomLineColor: "#e5e5e5", //

      labelsSize: 18,
      labelsColor: "#000000",

      starsColor: "#000000",
      starsSize: 45,

      inputBorderRadius: 5,
      inputBorderColor: "#e5e5e5",
      inputBorderSize: 1,
      inputBackground: "#ffffff",
      inputColor: "#000000",
      inputHelpTextColor: "#f5f5f5",
      inputHelpTextSize: 16,

      submitBtnTextSize: 18,
      submitBtnBackground: "#000000",
      submitBtnColor: "#ffffff",

      succesSubmissionMessageTextSize: 16,
      succesSubmissionMessageTextColor: "#059b05",
      succesSubmissionBorderColor: "#059b05",
      succesSubmissionBorderSize: 1,
      succesSubmissionBorderRadius: 0,
      succesSubmissionBackgroundColor: "#ffffff",
    },
  },
};

function Theme({ children, widget, context = "common" }) {
  const settings = useShopSettings();

  const customDesignAllowed = useLimitation("custom_design");

  const themeVariablesStyleString = useMemo(() => {
    const pairs = customDesignAllowed
      ? deepToPairs(settings?.customDesign?.[context]?.[widget] || {})
      : deepToPairs(DefaultTheme["common"][widget]);

    let styles = "";

    // TODO: Add merging pairs with defaults for case wnen add new fields
    const merged = {
      ...Object.fromEntries(deepToPairs(DefaultTheme["common"][widget])),
      ...Object.fromEntries(pairs),
    };

    Object.entries(merged).forEach(([key, value]) => {
      styles += `--${key}: ${value};`;
    });

    return styles;
  }, [settings, customDesignAllowed]);

  if (settings === null) {
    return null;
  }

  return <div style={themeVariablesStyleString}>{children}</div>;
}

export default Theme;
